import { Box, FormLabel } from "@mui/material";
import TooltipPopover from "../../../../components/shared/others/TooltipPopover";

const TooltipTotalPaid = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <TooltipPopover>
                Quantia paga pelo cliente. <br/>
                <br />
                Inclui juros e multas, por isso pode ser <br/>
                superior ao total cobrado.  
            </TooltipPopover>
        </Box>
    )
}

export default TooltipTotalPaid;